import loadable from "@loadable/component";
import { ErrorBoundary } from "../../components";
import FullPageLoader from "@Components/FullPageLoader";

const AsyncHowItWorksV2 = loadable(() => import("./HowItWorksV2"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <AsyncHowItWorksV2 {...props} />
  </ErrorBoundary>
);
